import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import {FormElementType} from "../../enums/formElementType";
import {LookupFieldType} from "~/enums/lookupFieldType";
import {Logger} from "~/services/logger";
import ObjectModel from "~/models/objectModel";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import ModelMappingOriginObjectModel, {IBuiltInPropertyValue} from "~/models/mapping/modelMappingOriginObjectModel";
import {IDefaultVOption, IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";
import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import ModelMappingOriginFormElement from "~/models/mapping/modelMappingOriginFormElement";
import {
  ObjectModelBuiltinPropertyCategories,
  ObjectModelBuiltinPropertyPermissions,
  ObjectModelBuiltinPropertyType,
  ObjectModelBuiltinPropertyTypeName
} from "~/enums/objectModelBuiltinPropertyType";
import {accessDisplay} from "~/enums/accessPermission";
import {ModelMappingRules} from "../../../formability/mappingBuilder/enums/model-mapping-rules";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";

export default class ModelMappingOriginLookupField extends ModelMappingOrigin<FormElement> {
  private _objectModel: ObjectModel
  private _objectModelMappingOrigin: ModelMappingOriginObjectModel
  canMatchUpdateRelationship: boolean = true

  get origin(): FormElement {
    return this.formElement
  }

  get identifier(): string {
    return this.origin?.client_id
  }

  get title(): string {
    return this.origin?.displayTitle
  }

  get values(): Array<ObjectModelProperty | IBuiltInPropertyValue> | Pick<FormElement, 'label_title' | 'client_id'>[] {
    if (this.origin.lookup_type === LookupFieldType.licenses) {
      return this.origin.licenses.map(license => ({
        label_title: license.title,
        client_id: license.client_id,
        labelSuffix: FormElementType.lookupField
      }))
    } else if (this.origin.lookup_type === LookupFieldType.objectModels) {
      if (this.objectModelMappingOrigin) {
        return this.objectModelMappingOrigin.values
      } else {
        Logger.logOnce('ModelMappingOriginLookupField', 'warn', 'Form Element\'s associated object model not found')
        return []
      }
    }
  }

  searchValues(query?: string, options: { filters?: ((value: string) => boolean)[], showUnmappedOnly?: boolean } = {}): Partial<this['values']> {
    // utilize the searchValues function in the object model mapping origin but have context this lookup field mapping origin
    // allows for usage of #values from this class
    return this.objectModelMappingOrigin.searchValues.bind(this)(query, options)
  }

  valueOptions(source: ModelMappingValueOrigin = null): IDefaultVOption[] | Array<IVOptionSetLocal> {
    return this.objectModelMappingOrigin.valueOptions(source)
  }

  get uploaderValueOptions(): IDefaultVOption[] {
    return this.objectModelMappingOrigin.uploaderValueOptions
  }

  mapValueToOption(value): IDefaultVOption {
    if (this.objectModelMappingOrigin) {
      return this.objectModelMappingOrigin.mapValueToOption(value)
    } else {
      Logger.logOnce('ModelMappingOriginLookupField', 'warn', 'Form Element\'s associated object model not found')
      return {label: "", value: undefined}
    }
  }

  get isSingle(): boolean {
    return this.formElementMappingOrigin?.isSingle
  }

  get objectModelMappingOrigin() {
    if (this.objectModel) {
      this._objectModelMappingOrigin = new ModelMappingOriginObjectModel(this.origin.object_model_for_mappings.client_id, this.modelMapping, this.mappingOrigin)
    }
    return this._objectModelMappingOrigin
  }

  get formElementMappingOrigin() {
    if (this.origin) {
      return new ModelMappingOriginFormElement(this.id, this.modelMapping, this.mappingOrigin)
    }
  }

  get objectModelId(): string {
    if (this.objectModel) {
      return this.objectModel.id
    }
  }

  private get objectModel(): ObjectModel {
    if (this._objectModel) return this._objectModel;
    const objectModelForMappings = this.origin?.object_model_for_mappings
    if (objectModelForMappings?.client_id) {
      this._objectModel = ObjectModel.repo.findOrCreate(objectModelForMappings.id, objectModelForMappings.client_id).loadFromJson(objectModelForMappings)
      return this._objectModel;
    } else {
      return null;
    }
  }

  private get formElement(): FormElement {
    return FormElement.repo.find(this.id);
  }
}